import React from 'react'
import ReactDOM from 'react-dom'
import { CssBaseline } from '@material-ui/core'
import CustomThemeProvider from './store/Theme'
import { SnackbarProvider } from 'notistack'
import { Provider } from 'react-redux'

import store from './redux/store'
import App from './App'
import './i18n'

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider
      maxSnack={30}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <CustomThemeProvider>
        <CssBaseline />
        <App />
      </CustomThemeProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById('root')
)
